import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CompanyBankAccounts } from "./CompanyBankAccounts";

export class UpdateBankAccountInformation {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly dispatcher_q: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:String, code?:String): Promise<any> {
    let args = { 
      bank_account_id: bank_account_id
    }
    if (code) {
      args['code'] = code
    }
    this.frontend.change_loading_update_info(bank_account_id, true)
    let res = await this.dispatcher.dispatch('bank_account_information.data', args)
    if (res.output['status'] === 'error') {
      this.frontend.show_update_error = true
    }
    this.frontend.change_loading_update_info(bank_account_id, false)
    // return await new CompanyBankAccounts(this.dispatcher_q, this.frontend).run(company_id, this.frontend.limit, this.frontend.offset)
  }
}